import { ExtraMenu } from 'library/styles/text';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import ROUTES from 'library/constants/routes';
import { getViewMode } from 'store/shared/selectors';
import { Container, ListItem, StyledLink } from './styles';

const Navigation = () => {
  const { pathname } = useLocation();
  const mode = useSelector(getViewMode);

  return (
    <Container>
      <ul>
        <ListItem isActive={pathname.includes(ROUTES.BROWSE)}>
          <StyledLink to={`${ROUTES.BROWSE}${mode}`}>
            <i className="icon-grid" />
            <ExtraMenu>
              Browse
            </ExtraMenu>
          </StyledLink>
        </ListItem>
        <ListItem isActive={pathname.includes(ROUTES.PROJECTS)}>
          <StyledLink to={`${ROUTES.PROJECTS}${mode}`}>
            <i className="icon-projects" />
            <ExtraMenu>
              Projects
            </ExtraMenu>
          </StyledLink>
        </ListItem>
        <ListItem isActive={pathname.includes(ROUTES.WISHLIST)}>
          <StyledLink to={`${ROUTES.WISHLIST}${mode}`}>
            <i className="icon-heart" />
            <ExtraMenu>
              Wishlist
            </ExtraMenu>
          </StyledLink>
        </ListItem>
        <ListItem isActive={pathname === ROUTES.SETTINGS}>
          <StyledLink to={ROUTES.SETTINGS}>
            <i className="icon-settings" />
            <ExtraMenu>
              Settings
            </ExtraMenu>
          </StyledLink>
        </ListItem>
      </ul>
    </Container>
  );
};

export default Navigation;
